import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const CookiePolicy = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Политика использования файлов Cookie</h1>

        <h2>1. Что такое файлы Cookie?</h2>

        <p>
          Cookie — это небольшие текстовые файлы, которые сохраняются на устройстве пользователя при посещении сайта.
        </p>

        <p>
          Они позволяют сайтам запоминать информацию о посещениях пользователя и улучшать работу сайта.
        </p>

        <h2>2. Использование Cookie на samzaim.ru</h2>

        <p>
          Samzaim использует файлы Cookie и аналогичные технологии для обеспечения работы сайта, анализа посещаемости и улучшения пользовательского опыта.
        </p>

        <p>
          Cookie могут быть собственными или принадлежать сторонним сервисам.
        </p>

        <h2>3. Какие Cookie мы используем</h2>

        <h3>Необходимые Cookie</h3>

        <p>
          Эти файлы необходимы для корректной работы основных функций сайта.
        </p>

        <p>
          Без них некоторые элементы сайта могут работать неправильно.
        </p>

        <h3>Аналитические Cookie</h3>

        <p>
          Мы используем аналитические Cookie для понимания того, как пользователи взаимодействуют с сайтом.
        </p>

        <p>
          Они могут собирать информацию:
        </p>

        <ul>
          <li>Количество посетителей;</li>
          <li>Посещенные страницы;</li>
          <li>Время пребывания на сайте;</li>
          <li>Тип устройства;</li>
          <li>Используемый браузер.</li>
        </ul>

        <h3>Партнерские Cookie</h3>

        <p>
          Некоторые ссылки на нашем сайте являются партнерскими.
        </p>

        <p>
          Партнерские Cookie помогают нашим партнерам отслеживать переходы и правильно учитывать комиссии.
        </p>

        <p>
          Использование таких Cookie не увеличивает стоимость услуг для пользователя.
        </p>

        <h2>4. Яндекс Метрика</h2>

        <p>
          Мы используем Яндекс Метрику для сбора статистики использования сайта.
        </p>

        <p>
          Яндекс Метрика может использовать Cookie для анализа:
        </p>

        <ul>
          <li>Источников переходов пользователей;</li>
          <li>Посещаемых страниц;</li>
          <li>Времени пребывания на сайте;</li>
          <li>Взаимодействия с контентом.</li>
        </ul>

        <h2>5. Управление Cookie</h2>

        <p>
          Пользователь может разрешить, заблокировать или удалить Cookie через настройки своего браузера.
        </p>

        <p>
          Большинство браузеров позволяют:
        </p>

        <ul>
          <li>Удалять сохраненные Cookie;</li>
          <li>Блокировать все Cookie;</li>
          <li>Получать уведомления перед сохранением Cookie.</li>
        </ul>

        <p>
          Отключение Cookie может повлиять на работу некоторых функций сайта.
        </p>

        <h2>6. Cookie сторонних сервисов</h2>

        <p>
          Некоторые сторонние сервисы могут устанавливать собственные Cookie в соответствии со своими политиками конфиденциальности.
        </p>

        <p>
          Рекомендуется ознакомиться с политиками таких сервисов.
        </p>

        <h2>7. Изменения Политики Cookie</h2>

        <p>
          Мы можем обновлять данную Политику Cookie при изменении законодательства, технологий или наших сервисов.
        </p>
      </Wrapper>
    </div>
  );
};

export default CookiePolicy;
